const hasItems = (value) => Array.isArray(value) && value.length > 0;
const getItems = (value) => (Array.isArray(value) ? value : []);

export const hasAssistantReviewWidgets = (message) =>
  Boolean(
    hasItems(message?.calendarEventDrafts) ||
      hasItems(message?.calendarEventDeletions) ||
      hasItems(message?.calendarEventUpdates) ||
      hasItems(message?.emailDrafts),
  );

export const getAssistantReviewStatusKeys = (message) => {
  if (!message?.id) return [];

  return [
    ...getItems(message.calendarEventDrafts).map(
      (draft) => `${message.id}::${draft.id || draft.startDateTimeIso}`,
    ),
    ...getItems(message.calendarEventDeletions).map(
      (deletion) => `${message.id}::${deletion.id || deletion.eventId}`,
    ),
    ...getItems(message.calendarEventUpdates).map(
      (update) => `${message.id}::${update.id || update.eventId}`,
    ),
    ...getItems(message.emailDrafts).map(
      (draft) => `${message.id}::${draft.id || draft.subject}`,
    ),
  ];
};
